// Domain Selector
export const DOMAIN_SELECTED = 'DOMAIN_SELECTED';
export const DOMAIN_CLEARED = 'DOMAIN_CLEARED';

// Domain Type Selector
export const CHANGE_DOMAIN_TYPE = 'CHANGE_DOMAIN_TYPE';
